import { render, staticRenderFns } from "./AwradListDefaultLayout.vue?vue&type=template&id=f0ca078a&scoped=true"
import script from "./AwradListDefaultLayout.vue?vue&type=script&lang=js"
export * from "./AwradListDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ca078a",
  null
  
)

export default component.exports